// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/payments/stylesheets/index.scss
 ** module id = 472
 ** module chunks = 1
 **/